import { gql } from '@apollo/client';

export const GET_PROJECT_MODULES_PERMISSIONS = gql`
  query projectConfigById($id: ID!) {
    projectConfigById(id: $id) {
      id
      modules {
        id
        name
        moduleTypeId
        permissions {
          id
          name
          permissionId
          applicableScopes {
            id
            name
          }
        }
      }
    }
  }
`;
